import { TFunction } from "i18next";
import * as yup from "yup";

interface Props {
  t: TFunction;
}

const ChildValidationSchema = ({ t }: Props) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
    nationalityId: yup.mixed().required(requiredMsg),
  });
};

export default ChildValidationSchema;
